import { useState } from "react";
import { FaSearch } from "react-icons/fa";
import SearchImg from "../../common/images/search-icon.png";

const steps = [
  {
    title: "Discovery & Planning",
    description:
      "We begin by understanding your business goals, challenges, and technical requirements to define a clear development roadmap.",
    icon: <FaSearch className="text-white text-xl" />,
  },
  {
    title: "Design & Prototyping",
    description:
      "Our designers create intuitive user interfaces and prototypes to provide you with a clear vision of the final product.",
  },
  {
    title: "Development & Integration",
    description:
      "Our developers use the latest technologies to build a secure, high-performing solution tailored to your business needs.",
  },
  {
    title: "Testing & Quality Assurance",
    description:
      "We conduct thorough testing to identify and resolve any issues, ensuring flawless performance.",
  },
  {
    title: "Deployment & Support",
    description:
      "We manage the deployment process and provide ongoing support to keep your software running smoothly",
  },
];

export default function OurProcess() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="max-w-[1280px] mx-auto md:px-10 px-5 py-7">
      {/* Header */}
      <div className="text-center mb-10">
        <h2 className="md:text-5xl text-3xl font-bold">Our Process</h2>
        <div className="underline md:w-1/5 w-2/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-black">
          <p className="h-[5px] rounded-xl bg-primary md:w-[50%] w-[70%]"></p>
        </div>
        <p className="text-black">
          We follow a structured and transparent development process to deliver
          reliable and effective solutions:
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 items-start border-t-[1px] border-webOranage">
        {/* Left Side Active Step */}
        <div className="flex small:min-h-full min-h-[300px] border-webOranage md:border-r-2 md:border-b-0 border-b-2 border-dotted">
          <div className="bg-[#0965AD] text-white py-6 px-4 w-20 flex flex-col items-center justify-between">
            <span className="text-3xl font-bold">0{activeIndex + 1}</span>
            <div className="small:pl-10 rotate-[-90deg] w-full text-lg tracking-wide whitespace-nowrap text-center">
              {steps[activeIndex].title}
            </div>
          </div>

          <div className="p-5 md:pr-5 pr-0 flex flex-col justify-around">
            <div className="mb-4">
              <img src={SearchImg} alt="search img" className="size-[100px]" />
            </div>
            <div>
              <h3 className="md:text-3xl small:text-2xl text-xl font-bold ">
                {steps[activeIndex].title.split("&")[0]}
                <span className="text-webOranage"> &</span>
                {steps[activeIndex].title.split("&")[1]}
              </h3>
              <p className="text-black small:text-md text-sm py-3 small:w-[70%]">
                {steps[activeIndex].description}
              </p>
            </div>
          </div>
        </div>

        {/* Right Step List - Exclude Active */}
        <div>
          {steps
            .map((step, i) => ({ ...step, index: i }))
            .filter((step) => step.index !== activeIndex)
            .map((step) => (
              <div
                key={step.index}
                onClick={() => setActiveIndex(step.index)}
                className={`flex items-center justify-between py-6 border-webOranage border-dashed border-b-2 cursor-pointer transition`}
              >
                <div className="flex items-center space-x-4 px-5">
                  <span className="text-3xl font-medium text-[#0965AD]">
                    0{step.index + 1}
                  </span>
                  <span className="text-gray-800 font-medium">{step.title}</span>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
